module.exports = __webpack_public_path__ + "static/media/logo_xglobal.278ac71e.png";